

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Autocomplete, Badge, Box, Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography, } from "@mui/material";
import Grid from "@mui/material/Grid";
import { loadingAction } from "ReduxReducers/loadingReducer";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getCurrencyCode } from "utils/api";
import { appConstants } from "utils/appConstants";
import { convertToTitleCase, getScreenRight, showResMsg, validateField, getFileType } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { SaveQuotation, UpdateQuotation, getContactsForQuotation, getItemsForQuotation, getQuotationDetailsByID, getQuotationExpiryValues } from "utils/quotationAPI";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { paymentTermsOptions } from "utils/generic";
import { AllKeysHaveValue } from "utils/generic";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import useTableStyles from "styles/customStyleItemTable";
import { ArrowDropDown, ConstructionOutlined, Update } from "@mui/icons-material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import { calculateAmounts } from "utils/generic";
import { calculatePrice } from "utils/generic";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { formatNumberWithCommas } from "utils/formatCurrency";
import FormattedNumberInput from "utils/formatCurrency";

const SCREEN_NAME = "Quotations";
let SCREEN_RIGHT;
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};


function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  setScreenName
}) {
  const apiFunction = isUpdate ? UpdateQuotation : SaveQuotation;

  apiFunction(values, (data) => {
    if (data?.Result_Status) {
      setOpen(false);

      console.log("redirectToOutside", redirectToOutside)
      if (redirectToOutside === 'redirectToItemWhenSave') {
        navigate(`/items/addItems?new=quotation&id=${data.Result_Output._id}`);
      }
      else if (redirectToOutside === 'redirectToEditItemWhenSave') {
        let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit")
        console.log("ItemIdForItemEdit", ItemIdForItemEdit)
        sessionStorage.removeItem("ItemIdForItemEdit");
        navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?source=quotation&id=${data.Result_Output._id || ''}`);
      }
      // else if (redirectToOutside === 'add-new') {
      //   let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit")
      //   console.log("ItemIdForItemEdit", ItemIdForItemEdit)
      //   sessionStorage.removeItem("ItemIdForItemEdit");
      //   navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?source=quotation&id=${data.Result_Output._id || ''}`);
      // }
      else {

        showResMsg(data.Result_Message, 2000, data.Result_Status, navigate, '/quotations');
        // let targetRoute = '/quotations';
        // showResMsg(data.Result_Message, 2000, data.Result_Status);

        // let targetRoute = `/quotations/edit/${data.Result_Output._id}`;
        // setScreenName("Edit Quotation");
        // navigate(targetRoute);
      }
    } else if (data.Result_Message === "ALREADY_EXIST_PO") {
      handleSoftDismisal();
    } else {
      if (data.Result_Output === "NO AVAILABLE CREDITS") {
        setShowBillingModal(true);
      }
      showResMsg(data.Result_Message, 2000, data.Result_Status);
    }
  }, dispatch);
}
function AddQuotation() {

  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const customStyles = useTableStyles();

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { id: QuotationID } = useParams();
  const showAddNewCustomer = QuotationID === undefined;
  const type = new URLSearchParams(window.location.search).get('type');
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [quotationNoErr, setQuotationNoErr] = useState(false);
  const [contactNameErr, setContactNameErr] = useState(false);
  const [contactDetails, setContactDetails] = useState([]);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [itemsDetails, setItemsDetails] = useState([]);
  const [screenName, setScreenName] = useState("Add New Quotation");
  const [showItemAndDocumentSection, setShowItemAndDocumentSection] = useState(false);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [selectedFileType, setSelectedFileType] = useState('');
  const [currencyCode, setCurrencyCode] = useState("");
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);
  const [quoDocuments, setDocuments] = useState([]);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
      discountType: "None", discountValue: "", discountAmount: "", totalItemPrice: 0,
    },
  ]);
  const apiItemCountRef = useRef(0);
  const itemRowValuesRef = useRef(itemRowValues);
  const isQuotationLoadedRef = useRef(false);
  const urlItemHandledRef = useRef(false);
  const apiItemsRef = useRef([]);
  const [quotationLoaded, setQuotationLoaded] = useState(false);
  // console.log("itemRowValues", itemRowValues)
  //Used for Modal Email Template 
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Quotation",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });

  const [values, setValues] = useState({
    token: useState(sessionStorage.getItem("TOKEN")),
    businessUserID: loginDetails?.businessUserID,
    userID: loginDetails?._id,
    quotationID: undefined,
    quotationNumber: 'Auto Generated',
    contactID: '',
    name: '',
    purchaseOrderNumber: '',
    quotationDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    quotationStatus: 'Pending',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: "0",
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
    documentName: "",
    sendEmailFlag: false,
    fileType: '',
  })

  const [fileError, setFileError] = useState('');
  const [finalise, setFinalise] = useState(false)

  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll('.Mui-disabled');
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName('input');

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }

    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }
  }, [itemRowValues, expanded])


  var disabledval = document.querySelectorAll('.Mui-disabled');
  for (let i = 0; i < disabledval.length; i++) {
    var usevalue = disabledval[i].getElementsByTagName('input');

    if (usevalue.length > 0) {
      if (darkMode) {
        usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");
      } else {
        usevalue[0].style.removeProperty("-webkit-text-fill-color");
      }
    }
  }

  useEffect(() => {
    console.log("itemRowValues changed", itemRowValues);
    console.log("itemRowValuesRef current", itemRowValuesRef.current);

    if (JSON.stringify(itemRowValues) !== JSON.stringify(itemRowValuesRef.current)) {
      itemRowValuesRef.current = itemRowValues;
      calculateDiscountAmount(itemRowValues);
    }
    addNewRowInList(itemRowValues);
    const filtered = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== undefined);
    if (filtered.length > 0) {
      setShowSendEmailBtn(filtered.every(row => row.itemID && row.itemPrice && row.itemQuantity))
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues,]);

  const fetchData = async () => {
    try {
      setScreenName(QuotationID ? (type !== "clone" ? "Edit Quotation" : "Clone Quotation ") : "Add New Quotation");
      setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

      await Promise.all([
        getRight(),
        LoadInitialData(),
        fetchCurrencyValue(),

      ])

      FetchQuotationDetailsByID();

    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch,]);



  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }
  const LoadInitialData = async () => {
    getContactsForQuotation(values, data => {
      if (data.Result_Output.length > 0) {
        setContactDetails(data.Result_Output);
      }
    }, dispatch)
  };

  let fetchCurrencyValue = async () => {
    await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
      if (data.Result_Status) {
        setCurrencyCode(data.Result_Output);
      }
    }), dispatch);
  }



  const FetchQuotationDetailsByID = async () => {
    console.log("FetchQuotationDetailsByID called")
    try {
      let detailsPromise;
      let itemsPromise;
      itemsPromise = new Promise((resolve, reject) => {
        getItemsForQuotation(values, data => {
          if (data.Result_Output.length > 0) {
            setItemsDetails(data.Result_Output);
            setMasterItemDetails(data.Result_Output);
            resolve();
          } else {
            reject(new Error("No items found for quotation"));
          }
        }, dispatch);
      });

      if (QuotationID) {
        values.quotationID = QuotationID;
        itemsPromise = new Promise((resolve, reject) => {
          getItemsForQuotation(values, data => {
            if (data.Result_Output.length > 0) {
              setItemsDetails(data.Result_Output);
              setMasterItemDetails(data.Result_Output);
              resolve();
            } else {
              reject(new Error("No items found for quotation"));
            }
          }, dispatch);
        });
        // Fetch quotation details fetchQuotationDetailsByID
        detailsPromise = new Promise((resolve, reject) => {
          getQuotationDetailsByID(values, (data) => {
            // FetchQuotationDetailsByID()
            let result = data.Result_Output[0];
            console.log("result.items", result)
            if (data.Result_Status) {
              setFinalise((result?.emailSent > 0) ? true : false);
              // setValues(prev => ({ ...prev, ...result }));
              setValues({ ...values, ...result, });
              const apiItems = result.items || [];
              apiItemsRef.current = apiItems;
              apiItemCountRef.current = apiItems.length; // 🔑 THIS WAS MISSING
              setQuotationLoaded(true);
              console.log("apiItemsRef.current", apiItemsRef.current)
              console.log("apiItemCountRef.current", apiItemCountRef.current)
              // apiItemsRef.current = result.items || [];
              if (result.items?.length > 0) {
                setItemRowValues([
                  ...apiItems,
                  { ...EMPTY_ITEM_ROW }
                ]);

              } else {
                setItemRowValues([{ ...EMPTY_ITEM_ROW }]);
              }

              // ✅ Mark API as loaded
              isQuotationLoadedRef.current = true;
              if (result.quotationDocuments?.length > 0) {
                setDocuments(result.quotationDocuments);
              }
              setShowItemAndDocumentSection(true);
              resolve();
            } else {
              showResMsg(data.Result_Message, 2000, false);
              navigate('/quotations')
              reject(new Error("No quotation details found"));
            }
          }, dispatch);
        });

      } else {
        dispatch(loadingAction(false))
      }
      await Promise.all([itemsPromise, detailsPromise]);
    }
    catch (error) {
      console.error("Error in FetchQuotationDetailsByID:", error);
      // Handle errors as needed
    }
  }



  //Handle Save or Update Quotation Function
  const handleChange = (name) => (event, newValue) => {
    let value = event.target.value;
    if (name === "totalDiscountAmount") {

      setValues(prev => ({ ...prev, totalDiscountAmount: value }));
      // handleCalculationDiscount(value)
    }

    if (name === "gstType") {
      setValues(prev => ({ ...prev, gstType: value }));
      handleCalculation(value);
    }
    else if (name === "contactID" && value === "add_new") {
      navigate("/contacts/addContact?new=quotation");
    }
    else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function calculateValidUpto(paymentTerm, quotationDate) {
    // console.log("quotationdate", quotationDate)
    const currentDate = new Date(quotationDate);
    currentDate.setHours(23, 59, 58, 999);
    // currentDate.setHours(0, 0, 0, 0);

    switch (paymentTerm) {
      case 'Same Day':
        return currentDate;

      case '7 Days':
        return addDays(currentDate, 7);

      case '14 Days':
        return addDays(currentDate, 14);

      case '30 Days':
        return addDays(currentDate, 30);

      case '14 Days End of Month':
        return addDays(endOfMonth(currentDate), 14);

      case '30 Days End of Month':
        return addDays(endOfMonth(currentDate), 30);

      default:
        throw new Error('Invalid payment term');
    }
  }

  const handleValidUptoDate = (paymentTerms) => {
    try {
      const validUptoDate = calculateValidUpto(paymentTerms, values.quotationDate);
      // console.log("validUptoDate", validUptoDate)
      setValues(prevValues => ({
        ...prevValues,
        validUptoDate: validUptoDate,
        validUpto: paymentTerms,
      }));
    } catch (error) {
      console.error(error.message);
    }
  };



  const handleChangeCustomer = (name) => (event, newValue) => {
    if (newValue) {
      if (newValue.value === 'add-new') {
        // if (QuotationID) {

        //   navigate(`/contacts/addContact?new=quotation&redirect=/quotations/edit/${InvoiceID}`);
        // } else {
        //   navigate("/contacts/addContact?new=quotation&redirect=/quotations/add");
        // }
        navigate("/contacts/addContact?new=quotation")
      } else {
        const paymentTerms = contactDetails.find(customer => customer._id === newValue.value).paymentTerms || "30 Days End of Month";
        handleValidUptoDate(paymentTerms);
        setValues(prevValues => ({
          ...prevValues,
          [name]: newValue.label,
          contactID: newValue.value
        }));
      }
    }
    else {
      setValues({ ...values, [name]: '', contactID: '' });
    }
  }

  const handleDateChange = (key) => (date) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: date,
    }));
  };

  const handleValidUpto = (name) => (event) => {
    if (name === 'validUpto') {
      handleValidUptoDate(event.target.value);
    }
  }
  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setQuotationNoErr(false);
  }
  const removeUndefinedParameter = () => {

    delete values.totalAmount;
    delete values.totalDiscountAmount;
    delete values.totalGSTAmount;
    delete values.finalAmount;
    delete values.paymentInstruction;
    delete values.documentName;
  }

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      if (!row.itemID || !row.itemPrice || !row.itemQuantity || !row.categoryCodeName) {
        missingItems.push(index + 1);
      }
    });

    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage = "Please fill in all of the following items before creating the quotation:\n";
    missingItems.forEach(itemIndex => {
      missingItemsMessage += `Row ${itemIndex}: `;
      if (!itemRowValues[itemIndex - 1].itemID) {
        missingItemsMessage += "Item Name, ";
      }
      if (!itemRowValues[itemIndex - 1].itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!itemRowValues[itemIndex - 1].itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }

      if (!itemRowValues[itemIndex - 1].categoryCodeName) {
        missingItemsMessage += "Account Name, ";
      }
      missingItemsMessage = missingItemsMessage.slice(0, -2); // Remove the last comma and space
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }

  //Handles Item Rows Functions
  const handleEdit = (id, index) => {
    console.log("handleEdit called id with index:", id, index);
    sessionStorage.setItem("ItemIdForItemEdit", id);
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to Edit the Item?",
      "warning",
      darkMode,
      async () => {
        await handleSaveQuotation('redirectToEditItemWhenSave');
        // handleSaveQuotation(redirectToItemWhenSave);
        // navigate(`/items/editItem/${itemRowValues[index].itemID}?source=quotation&id=${QuotationID || ''}`);
      }
    );

  };

  const handleSaveQuotation = async (redirectToOutside = null,) => {
    console.log("handleSaveQuotation called", redirectToOutside)

    delete values.token
    type && (values.type = type);
    clearAllErrorMsg();
    let mandateFlag = false;

    let quotationDate = new Date(values.quotationDate);
    let validUptoDate = new Date(values.validUptoDate);
    if (validUptoDate < quotationDate) {

      return showResMsg("Valid upto date should be more than Quotation date.", 2000, false);
    }

    mandateFlag = validateField(values.quotationNumber, setQuotationNoErr) || mandateFlag;
    if (!values.contactID || values.contactID === '') {
      mandateFlag = validateField(values.contactID, setContactNameErr) || mandateFlag;
      return;
    }


    if (QuotationID) {
      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);
      console.log("filterItemList", filterItemList)
      console.log("redirectToOutside", redirectToOutside)


      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName && row.discountValue !== "");
        console.log("allRowsFilled", allRowsFilled)

        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else {
        console.log("redirectToOutside", redirectToOutside)
        if (redirectToOutside === 'redirectToItemWhenSave') {
          navigate(`/items/addItems?new=quotation&id=${QuotationID}`);
          return;
        } else {
          showResMsg("Please select at least 1 Item", 2000, false);
          return;
        }
        // if (redirectToOutside !== 'redirectToItemWhenSave') {
        //             console.log("redirectToOutside", redirectToOutside)
        // showResMsg("Please select at least 1 Item", 2000, false);

      }

      if (quoDocuments.length > 0) {
        values.hasQuo_DocumentFile = true;
      } else {
        values.hasQuo_DocumentFile = false;
      }
    }
    else {
      // removeUndefinedParameter();

      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);
      console.log("filterItemList", filterItemList)
      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName);

        if (allRowsFilled) {
          values.itemsList = filterItemList;

        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      }
      // else if (redirectToOutside === 'redirectToItemWhenSave') {
      //   navigate(`/items/addItems?new=quotation&id=${QuotationID}`);
      // }
      else {
        if (redirectToOutside === 'redirectToItemWhenSave') {
          values.itemsList = [];
          console.log("redirectToOutside", redirectToOutside)
        } else {
          showResMsg("Please select at least 1 Item", 2000, false);
          return;
        }


      }
    }

    if (mandateFlag) return
    //add cuurency value
    values.currencyValue = currencyCode;

    handleApiResponse({
      isUpdate: QuotationID !== undefined,
      values,
      setOpen,
      showResMsg,
      navigate,
      handleSoftDismisal,
      setShowBillingModal,
      dispatch,
      setScreenName,
      redirectToOutside: redirectToOutside,

    });

  }


  const handleCancel = (index) => {
    ShowSwalWithButtons(
      'Are you sure?',

      `Would you like to exit from this ${QuotationID
        ? "Edit Quotation"
        : "Add New Quotation"
      }?`,
      'warning',
      darkMode,
      () => {
        let routePath = '/quotations'; // default
        navigate(routePath); // ✅ redirect user
      }
    );

  };
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      'Do you wish to continue?',
      'warning',
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveQuotation();
      }
    );
  }
  const handleSaveWithSendEmail = () => {
    values.sendEmailFlag = true;
    handleSaveQuotation();
  }



  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to remove the Item?",
      "warning",
      darkMode,
      () => {
        console.log("handleRemove called with index:", index);
        if (itemRowValues.length > 1) {
          const list = [...itemRowValues];
          list.splice(index, 1);
          setItemRowValues(list);
        } else {
          setItemRowValues([{
            itemName: "", itemID: "", itemPrice: "", itemQuantity: "", itemDescription: "", categoryCodeName: "", gst: "",
            discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: 0,
          }])
        }
      }
    );

  };
  // const addNewRowInList = (rows) => {
  //   const lastRow = rows[rows.length - 1];
  //   if (lastRow?.itemID) {
  //     setItemRowValues([...rows, { ...EMPTY_ITEM_ROW }]);
  //   }
  // };

  const ensureEmptyRowAtEnd = (rows) => {
    const lastRow = rows[rows.length - 1];
    if (lastRow?.itemID) {
      return [...rows, { ...EMPTY_ITEM_ROW }];
    }
    return rows;
  };
  const addNewRowInList = (updatedRows) => {
    const emptyRowCount = updatedRows.filter(row => row.itemID === "" || row.itemID === undefined).length;
    if (emptyRowCount < 1) {
      setItemRowValues([
        ...updatedRows,
        {
          itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
          discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: 0,
        }
      ]);
    }
  };

  const calculateDiscountAmount = (itemRowValues) => {
    console.log("calculateDiscountAmount called", itemRowValues)
    const updatedRows = itemRowValues.map((item, idx) => {
      const itemPrice = parseFloat(item.itemPrice);
      const itemQuantity = parseFloat(item.itemQuantity);
      const discountValue = parseFloat(item.discountValue);
      let discountAmount = 0;
      const totalAmount = itemPrice * itemQuantity;
      if (item.discountType === "Percentage") {
        discountAmount = totalAmount * discountValue / 100;
      } else {
        discountAmount = discountValue;
      }

      return { ...item, discountAmount: parseFloat(discountAmount.toFixed(2)) || 0 };
    });

    setItemRowValues(updatedRows);
    handleCalculation(values.gstType || "Inclusive");
  };

  const handleCalculation = (gstType) => {
    let TotalAmount = 0;
    let TotalDiscountAmount = 0;
    let TotalGSTAmount = 0;
    let FinalAmount = 0;

    itemRowValues
      .filter(item => item.itemID) // 🔑 ignore empty row
      .forEach(item => {
        let itemPrice = item.itemPrice || 0;
        let itemQuantity = item.itemQuantity || 0;
        let discount = item.discountAmount || 0;
        let gst = item.gst || 0;
        let itemTotalPrice = itemPrice * itemQuantity;
        let baseAmount = 0;
        let taxAmount = 0;
        console.log("gstType in handleCalculation", gstType)
        if (["Inclusive", undefined].includes(gstType)) {
          const customerPayableAmount = itemTotalPrice;
          const Amount = calculatePrice(customerPayableAmount, gst, discount);

          baseAmount = Amount.itemActualPrice;
          taxAmount = Amount.taxAmount;
        } else {
          baseAmount = itemTotalPrice;
          taxAmount = gst * (itemTotalPrice - discount) / 100;
        }
        TotalAmount += baseAmount;
        TotalDiscountAmount += discount;
        TotalGSTAmount += taxAmount;
      });
    if (gstType === "Inclusive" || gstType === undefined) {
      FinalAmount = parseFloat(TotalAmount + TotalGSTAmount).toFixed(2);
    } else {
      FinalAmount = parseFloat((TotalAmount - TotalDiscountAmount) + TotalGSTAmount).toFixed(2);
    }

    setValues(prevValues => ({
      ...prevValues,
      totalAmount: parseFloat(TotalAmount).toFixed(2),
      totalDiscountAmount: parseFloat(TotalDiscountAmount).toFixed(2),
      totalGSTAmount: parseFloat(TotalGSTAmount).toFixed(2),
      finalAmount: parseFloat(FinalAmount).toFixed(2)
    }));

  }


  const handleItemRowChange = async (name, value, index) => {
    console.log("TTT", name, value, index)
    const updatedRows = [...itemRowValues];
    // if (name === 'itemPrice' || name === 'itemQuantity') {
    if (value === '.') {
      value = '0.';
    }

    const regex = /^\d{1,7}(?:\.\d{0,2})?$/;

    if (regex.test(value) || value === "") {

      if (name === 'itemPrice' || name === 'itemQuantity') {
        if (parseFloat(value) === 0 || value === "") {
          showResMsg(`${await convertToTitleCase(name)} cannot be zero`, 1000, false)
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        updatedRows[index].totalItemPrice = parseFloat((updatedRows[index].itemPrice) * (updatedRows[index].itemQuantity)).toFixed(2);
        setItemRowValues(updatedRows);
      }
      else if (name === 'discountValue') {
        console.log("discountValue called")
        if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
          if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }

          if (value === "" || (parseFloat(value) < (parseFloat(itemRowValues[index].itemPrice) * parseFloat(itemRowValues[index].itemQuantity)) && itemRowValues[index].discountType === "Fixed")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }
        }
      }
    } else if (name === 'discountValue') {

      if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
        if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }

        if (value === "" || (parseFloat(value) < parseFloat(itemRowValues[index].itemPrice) && itemRowValues[index].discountType === "Fixed")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }
      }
    } else if (name === "discountType" && value === "None") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountValue: 0, discountAmount: 0 };
      setItemRowValues(updatedRows);
    } else if (name === "discountType" && value === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(itemRowValues[index].discountValue) };
      setItemRowValues(updatedRows);
    } else if (name === "discountValue" && itemRowValues[index].discountType === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(value) };
      setItemRowValues(updatedRows);
    } else {
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      setItemRowValues(updatedRows);
    }
  };
  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const EMPTY_ITEM_ROW = {
    itemID: "",
    itemName: "",
    itemPrice: "",
    itemDescription: "",
    categoryCodeName: "",
    itemQuantity: "",
    gst: "",
    discountType: "None",
    discountValue: "",
    discountAmount: 0,
    totalItemPrice: 0,
  };


  const handleItemRow = async (name, newValue, index) => {
    console.log("handleItemRow called with newValue:", newValue, "at index:", index);
    if (newValue.value === "add-new") {
      handleAddNewItem();
      return;
    } else {
      const selectedItem = masterItemDetails.find(item => item._id === newValue.value);
      if (selectedItem) {
        const updatedRows = [...itemRowValues];
        updatedRows[index] = {
          ...updatedRows[index],
          itemID: newValue.value,
          itemName: selectedItem.itemName,
          itemDescription: selectedItem.itemDescription ? selectedItem.itemDescription : selectedItem.itemName,
          categoryCodeName: selectedItem.categoryCodeName,
          itemPrice: parseFloat(selectedItem.itemPrice),
          itemQuantity: parseFloat(selectedItem.itemQuantity),
          totalItemPrice: (parseFloat(selectedItem.itemPrice).toFixed(2)) * (parseFloat(selectedItem.itemQuantity).toFixed(2)),
          gst: parseFloat(selectedItem.gst),
          discountType: selectedItem.discountType,
          discountValue: parseFloat(selectedItem.discountValue).toFixed(2),
          discountAmount: selectedItem.discountType === "Fixed" ? selectedItem.discountValue : 0,
        };
        setItemRowValues(updatedRows);
        handleCalculation(values.gstType);
      }
    }

    // const itemId = newValue.value;
    // const selectedItem = masterItemDetails.find(item => item._id === itemId);
    // console.log("Selected Item:", selectedItem);

    // if (!selectedItem) return;

    // setItemRowValues(prev => {
    //   const updated = [...prev];

    //   // 🔑 FORCE index to be after API items
    //   const targetIndex = Math.max(index, apiItemCountRef.current);

    //   updated[targetIndex] = {
    //     ...updated[targetIndex],
    //     itemID: selectedItem._id,
    //     itemName: selectedItem.itemName,
    //     itemDescription: selectedItem.itemDescription || selectedItem.itemName,
    //     categoryCodeName: selectedItem.categoryCodeName,
    //     itemPrice: Number(selectedItem.itemPrice).toFixed(2),
    //     itemQuantity: Number(selectedItem.itemQuantity),
    //     totalItemPrice:
    //       Number(selectedItem.itemPrice) * Number(selectedItem.itemQuantity),
    //     gst: selectedItem.gst,
    //     discountType: selectedItem.discountType,
    //     discountValue: selectedItem.discountValue,
    //     discountAmount:
    //       selectedItem.discountType === "Fixed"
    //         ? selectedItem.discountValue
    //         : 0,
    //   };
    //   return ensureEmptyRowAtEnd(updated);

    // });

  };


  const filteredOptions = itemsDetails
    .map(item => ({
      label: item.itemName,
      value: item._id,
    }));


  const coloredShadowChange = document.querySelectorAll(".dayHour");
  if (coloredShadowChange) {
    for (let i = 0; i < coloredShadowChange.length; i++) {
      coloredShadowChange[i].style.color = darkMode ? "white" : "black";

    }

  }


  const labelStyles = {
    label: {
      style: {
        color: darkMode ? tableBorder : tableBorder
      }
    }
  }

  let columns = [

    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Autocomplete
              disableClearable
              key={`${i}-${row.itemID}`}
              id={`item-${i}`}
              options={[{ label: "Add New Item", value: "add-new", }, ...filteredOptions]}
              onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
              value={row.itemName}
              sx={{
                '& .MuiInputBase-root': {
                  width: "170px",
                  marginTop: "4px"
                },
              }}
              isOptionEqualToValue={(option, value) => option.label === value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoFocus
                  variant="standard"
                  placeholder="Search for an Item"
                  size="medium"
                  style={{ height: "35.11px" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 350,
                      },
                    },
                  }}

                  sx={{
                    "& .MuiInput-root": {
                      color: " #000000",
                      fontFamily: "Roboto",
                      "&:before": {
                        borderColor: darkMode ? "white" : tableBorder,
                      },
                      "&:after": {
                        borderColor: darkMode ? tableBorder : tableBorder,
                      },
                    },
                  }}
                  inputProps={{
                    ...params.inputProps,
                    maxLength: 200,   // ⭐ Max length applied
                  }}
                />
              )}
              renderOption={(props, option) => {
                // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
                const customStyle = option.value === 'add-new'
                  ? (darkMode ? tableBorder : tableBorder)
                  : (darkMode ? 'autoCompleteDarkList' : 'autoCompleteList');
                return (
                  <li
                    {...props}
                    key={option.value}
                    style={{ fontSize: '12px', color: darkMode ? tableBorder : tableBorder, padding: "4.8px 16px", fontWeight: "bold", fontFamily: "Roboto, Helvetica, Arial, sans-serif", cursor: 'pointer' }}
                    className={customStyle}

                  >
                    {option.label}
                  </li>
                );
              }}
              filterOptions={(options, state) => {
                const filtered = options.filter(option => option.label.toLowerCase().includes(state.inputValue.toLowerCase()));

                if (!filtered.some(option => option.value === 'add-new')) {
                  filtered.unshift({ label: "Add New Item", value: "add-new" });
                }
                return filtered;
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '170px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) => handleItemDescription("itemDescription", event.target.value, i)}
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              variant="standard"
              sx={{
                '& .MuiInputBase-root': {
                  width: "320px",
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: '12px',
                  whiteSpace: 'pre-wrap',
                  overflowWrap: 'break-word',
                  width: "100%",
                  color: darkMode ? "white" : "black",
                  minWidth: '300px',
                  boxSizing: 'border-box',
                  display: 'block',
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '260px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              // className="removeExtraPadding"

              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, "")}
              inputProps={{
                maxLength: 5,
                // pattern: "[]",
                pattern: "^[0-9]+$",
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) => handleItemRowChange("itemQuantity", event.target.value, i)}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatNumberWithCommas(row.itemPrice)}
              variant="standard"
              onChange={(event) => handleItemRowChange("itemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              inputProps={{
                maxLength: 8,
                // pattern: "[]",
                pattern: "^[0-9]+$",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.totalItemPrice)}
              variant="standard"
              disabled
              // onChange={(event) => handleItemRowChange("totalItemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) => handleItemRowChange("categoryCodeName", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '200px',
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth

              sx={{
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) => handleItemRowChange("gst", event.target.value, i)}
              disabled
              style={{ cursor: 'default', pointerEvents: 'none' }}

            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Type</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: -1.5 }}>
              <Select
                style={{ height: "35.11px", marginTop: "1.5px" }}
                labelId="day-hours-select-label"
                id="day-hours-select"
                className="dayHour"
                value={row.discountType}
                onChange={(event) => handleItemRowChange("discountType", event.target.value, i)}
                fullWidth
                sx={{
                  width: "100px"
                  ,
                  color: darkMode ? "white" : "black",
                  '& .MuiInputBase-root ': {


                  },
                  '&:before': {
                    borderBottomColor: darkMode ? "white" : tableBorder,
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    borderBottomColor: darkMode ? "white" : tableBorder
                  },
                  '&:after': {
                    borderBottomColor: darkMode ? tableBorder : tableBorder,
                  },
                  '& .MuiSelect-select': {
                    color: darkMode ? "white" : "black",
                  },
                }}
                variant="standard"
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Fixed">Fixed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '140px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Value</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth
              sx={{
                color: darkMode ? "white" : "black",
                '& .MuiInputBase-input ': {

                  marginTop: "4px"
                },
                "& .MuiInput-root": {
                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              disabled={row.discountType === "None"}
              // value={row.discountType === "None" ? 0 : row.discountValue}
              value={row.discountType === "None" ? 0 : row.discountValue ?? ""}
              onChange={(event) => handleItemRowChange("discountValue", event.target.value, i)}
              inputProps={{
                maxLength: 30,
                pattern: "^[a-zA-Z0-9 ]+$",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },

    },

    {
      // name: "Action",
      name: <p></p>,
      selector: (row) => row._id,
      cell: (row, i) => (
        <>
          <Grid container style={{ display: "flex", justifyContent: "center" }} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              {row.itemID ?
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i);
                  }}
                  title="Delete"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="delete"
                  title="Delete"
                />
              }
            </Grid>
            <Grid item>
              {row.itemID ?
                <TimelineItem
                  color="success"
                  icon="edit"
                  onClick={() => {
                    handleEdit(row.itemID, i);
                  }}
                  title="Edit"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="edit"
                  title="Edit"
                />
              }
            </Grid>
          </Grid>
        </>
      ),



    },
  ];

  //Quotation Document Functions Start here....
  const saveFile = async (event) => {
    const file = event.target.files[0];
    console.log("file", file)
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
    console.log("fileName", fileNameWithoutExtension);
    // if (!values.documentName) {
    setValues((prev) => ({
      ...prev,
      documentName: fileNameWithoutExtension,
    }));
    // }

    if (file && file.type) {
      if (file.size > 1 * 1024 * 1024) {
        setFileError('File size should be less than 1 MB');
        return;
      } else {
        setFileError('');
        document.getElementById("quotationDocument").value = file.name;
        console.log("values.documentName", values.documentName)
        if (file) {
          try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("quotationID", values.quotationID);
            formData.append("documentName", fileNameWithoutExtension);
            formData.append("fileType", await getFileType(file.type))
            values.selectedID && formData.append("documentID", values.selectedID);
            dispatch(loadingAction(true));
            await axios.post(appConstants.baseURL + "quotation/uploadQuotationDocument", formData).then(res => {
              let response = res.data;
              dispatch(loadingAction(false));
              showResMsg(response.Result_Message, 1000, response.Result_Status);
              if (response.Result_Status) {
                // setShowItemAndDocumentSection(true);
                setValues({ ...values, documentName: "", selectedID: "" });
                setDocuments(response.Result_Output);
                document.getElementById("quotationDocument").value = "";
              }
            })
          } catch (error) {
            console.log("error addDocument", error);
          }
        }
      }
    } else {
      console.log('No file selected or file object is false/undefined');
      showResMsg('Please select a valid file!', 2000, false);
      setFileError('');
    }
  };
  const handleEditDocument = (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to edit "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      () => {
        setValues({ ...values, documentName: selectedDocRow.documentName, selectedID: selectedDocRow._id });
      },
    );

  }
  const handleDeleteDocument = async (selectedDocRow) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to delete "${selectedDocRow.documentName}" file?`,
      "warning",
      darkMode,
      async () => {
        await axios.post(appConstants.baseURL + "quotation/deleteQuotationDocument", { documentID: selectedDocRow._id }).then(
          res => {
            if (res.data.Result_Status) {
              showResMsg(res.data.Result_Status ? genericMessage.documentDeleted : res.data.Result_Message, 1000, res.data.Result_Status);
              const updatedQuoDocument = quoDocuments.filter(item => {
                return item.documentName !== selectedDocRow.documentName;
              });
              setDocuments(updatedQuoDocument);
            } else {
              showResMsg(res.data.Result_Message, 1000, false);
            }
          }).catch(error => {
            console.log("deleteQuotationDocument error", error.message);
          })
      },
    )

  }
  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: 'true',
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            {/* <Grid item>
              <TimelineItem color="success" icon="edit" title="Edit"
                onClick={() => { handleEditDocument(row) }}
              />

            </Grid> */}

            <Grid item>
              {row.fileType === "pdf" || row.fileType === "image" ?
                <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => { handleViewDocument(row) }}
                  title="View"
                /> :
                <a className="testing" href={appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + row.documentFileName} download target="_blank" rel="noopener noreferrer">
                  <TimelineItem
                    color="info"
                    icon="visibility"
                    onClick={() => { renderFilePreview(row) }}
                    title="View"
                  />
                </a>
              }

            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDocument(row)}
                title="Delete"
                disabled={SCREEN_RIGHT === "View Only"}
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];
  const handleViewDocument = (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (selectedDocRow.fileType === "pdf" || selectedDocRow.fileType === "image") {
      const path = appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName;
      setSetDocumentFileURL(path);
      path && setViewDocumentInModal(true);
    } else {
      showResMsg("Document type not supported.", 2000, false)
    }

  };
  const renderFilePreview = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
  };
  const handleCloseViewModal = () => {
    setSetDocumentFileURL('');
    setSelectedFileType('');
    setViewDocumentInModal(false);
  }
  //Quotation Document Functions Ends here....



  const handleAddNewItem = async (value) => {
    console.log("handleAddNewItem called", value)

    console.log("redirectToOutside")
    await handleSaveQuotation('redirectToItemWhenSave');
  }
  //Modal Email Template used fxn start
  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: values.contactID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg(data.Result_Message, 2000, false);
          setOpen(false);
        }
      }, dispatch);
    }
  }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    console.log("PlayLoad", values.templateValues)

    handleSaveQuotation();
    setOpen(false)
  }
  //Modal Email Template used fxn ends
  useEffect(() => {
    const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
    if (contactFromUrl) {
      if (contactFromUrl === 'add-new') {
        handleChangeCustomer('name')('', { label: 'Add New Customer', value: 'add-new' });
      } else {
        const selectedContact = contactDetails.find(contact => contact._id === contactFromUrl);
        if (selectedContact) {
          handleChangeCustomer('name')('', { label: selectedContact.companyName, value: contactFromUrl });
        }
      }
    }

  }, [contactDetails]);

  useEffect(() => {
    if (
      !quotationLoaded ||           // ✅ STATE, not ref
      !masterItemDetails.length
    ) return;
    const itemId = new URLSearchParams(window.location.search).get('item');

    console.log("itemId from URL:", itemId);
    if (!itemId) return;
    // ⛔ prevent duplicate insertion
    if (urlItemHandledRef.current) return;

    const selectedItem = masterItemDetails.find(
      item => item._id === itemId
    );

    if (!selectedItem) return;

    const urlItemRow = {
      itemID: selectedItem._id,
      itemName: selectedItem.itemName,
      itemDescription: selectedItem.itemDescription || selectedItem.itemName,
      categoryCodeName: selectedItem.categoryCodeName,
      itemPrice: Number(selectedItem.itemPrice),
      itemQuantity: Number(selectedItem.itemQuantity),
      gst: selectedItem.gst,
      discountType: selectedItem.discountType,
      discountValue: selectedItem.discountValue,
      discountAmount: 0,
      totalItemPrice: Number(selectedItem.itemPrice),
    };

    setItemRowValues(prev => {
      // remove EMPTY rows first
      const rowsWithoutEmpty = prev.filter(row => row.itemID);

      // avoid adding same URL item again
      const alreadyExists = rowsWithoutEmpty.some(
        row => row.itemID === itemId
      );

      if (alreadyExists) return prev;

      // ✅ mark URL item as handled
      urlItemHandledRef.current = true;

      return [
        ...rowsWithoutEmpty, // API items
        urlItemRow,          // URL item
        { ...EMPTY_ITEM_ROW }
      ];
      // setItemRowValues(prev => {
      //   const rowsWithoutEmpty = prev.filter(
      //     row => row.itemID || row.itemName
      //   );

      //   return [
      //     ...rowsWithoutEmpty, // API items
      //     urlItemRow,          // URL item
      //     { ...EMPTY_ITEM_ROW }
      //   ];
    });



  }, [quotationLoaded, masterItemDetails]);



  // useEffect(() => {
  //   const itemFromUrl = new URLSearchParams(window.location.search).get('item');

  //   console.log("itemFormUrl", itemFromUrl)
  //   if (itemFromUrl) {
  //     const selectedItem = masterItemDetails.find(item => item._id === itemFromUrl);
  //     console.log("selectedItem", selectedItem)
  //     if (selectedItem) {
  //       const newItemValue = { value: itemFromUrl };
  //       console.log("itemRowValues", itemRowValues)
  //       // Find the first empty row (if any)
  //       const emptyRowIndex = itemRowValues.findIndex(row => !row.value);
  //       console.log("before-emptyRowIndex", emptyRowIndex)
  //       if (emptyRowIndex) {
  //         // Update the first empty row found
  //         console.log("emptyRowIndex > 0", emptyRowIndex)
  //         handleItemRow('', newItemValue, emptyRowIndex);
  //       } else {
  //         // If no empty row is found, update the last row or add new row logic
  //         const lastIndex = itemRowValues.length - 1;
  //         console.log("lastIndex", lastIndex)
  //         handleItemRow('', newItemValue, lastIndex);
  //         console.warn('No empty row found, updating the last row instead');
  //       }
  //     }

  //   }
  // }, [masterItemDetails]);

  useEffect(() => {
    if (!itemRowValues.length) return;

    handleCalculation(values.gstType);
  }, [itemRowValues, values.gstType]);

  const customerOptions = [
    ...(showAddNewCustomer ? [{ label: 'Add New Customer', value: 'add-new' }] : []),
    ...contactDetails.map(contact => ({
      label: contact.companyName,
      value: contact._id
    }))
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container px={2} mt={2} spacing={2}>

            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={12}>

              <Autocomplete
                id="customerName-select"
                options={customerOptions}
                // options={[
                //   { label: 'Add New Customer', value: 'add-new' },
                //   ...contactDetails.map(contact => ({ label: contact.companyName, value: contact._id }))
                // ]}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.value}
                    className={
                      darkMode ?
                        `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteDarkList'}` :
                        `${option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}`
                    }
                  >
                    {option.label}
                  </li>
                )}
                // filterOptions={(options, state) => {
                //   const filtered = options.filter(option =>
                //     option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                //   );
                //   if (!filtered.some(option => option.value === 'add-new')) {
                //     filtered.unshift({ label: 'Add New Customer', value: 'add-new' });
                //   }

                //   return filtered;
                // }}
                filterOptions={(options, state) => {
                  const filtered = options.filter(option =>
                    option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                  );

                  if (
                    showAddNewCustomer &&
                    !filtered.some(option => option.value === 'add-new')
                  ) {
                    filtered.unshift({ label: 'Add New Customer', value: 'add-new' });
                  }

                  return filtered;
                }}
                onChange={handleChangeCustomer("name")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.label === value;
                }}

                value={
                  (values.contactID && contactDetails.find(contact => contact._id === values.contactID)?.companyName) ||
                  (new URLSearchParams(window.location.search).get('contact') === 'add-new' ? 'Add New Customer' : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Customer"
                    autoFocus={true}
                    placeholder="Enter Customer Name"
                    inputProps={{
                      ...params.inputProps,
                      maxLength: 25,   // <-- ⭐ Max 25 characters
                    }}
                  />
                )}
                disabled={QuotationID && finalise}
              />

              {contactNameErr ? <p style={errMsg}>Please select Customer.</p> : ""}
            </Grid>

            <Grid item lg={3} xs={12}>
              <PickDate
                style={{ height: "35px" }}
                selected={new Date(values.quotationDate)}
                onChange={handleDateChange('quotationDate')}
                label="Quotation Date"
                variant="outlined"

                disabled={QuotationID}
                InputLabelProps={{ shrink: true }}
                minDate={new Date()} />
            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Valid Upto</InputLabel>
                <Select
                  labelId="validUpto-label"
                  label="Valid Upto"
                  style={{ height: "35px" }}
                  onChange={handleValidUpto("validUpto")}
                  value={values.validUpto}
                  displayEmpty
                >
                  <MenuItem disabled value="">Select Valid Upto</MenuItem>
                  {paymentTermsOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>{option}</MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Grid>
            <Grid item lg={3} xs={12}>

              <PickDate
                selected={new Date(values.validUptoDate)}
                onChange={handleDateChange('validUptoDate')}
                label="Valid Upto Date"
                minDate={new Date()}
              />
            </Grid>
            {/* Quotation Number */}
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Quotation Number"
                variant="outlined"
                // onChange={handleChange('quotationNumber')}
                disabled
                fullWidth
                inputProps={{
                  maxLength: 12,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  // style: { padding: '9px' } 
                  className: "custom-fieldtext"
                }}
                value={values.quotationNumber}
              />
              {quotationNoErr ? <p style={errMsg}>Quotation Number can't be blank.</p> : ""}
            </Grid>
            {/* Reference Number */}
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth

                inputProps={{
                  maxLength: 50,
                  // pattern: "^[a-zA-Z0-9!#$%^&*()_+=-{};:'<>,./?]+$",
                  className: "custom-fieldtext"
                }}
                disabled={QuotationID && finalise}
                value={values.purchaseOrderNumber}
                onChange={handleChange('purchaseOrderNumber')}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35px" }}
                  disabled
                  label="Status"
                  value={values.quotationStatus}
                  onChange={handleChange('quotationStatus')}
                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>
          <Grid container spacing={2}>


          </Grid>
          {/* {showItemAndDocumentSection && QuotationID && <> */}
          <Grid container mt={2} columnSpacing={4} px={2}>
          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>

          <Grid container style={{ marginTop: '10px' }} px={2} spacing={2}>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Base Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values.totalAmount)}
                onChange={handleChange('totalAmount')}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total Discount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                disabled
                InputLabelProps={{ shrink: true }}
                value={values.totalDiscountAmount}
                onChange={handleChange('totalDiscountAmount')}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  onChange={handleChange('gstType')}
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total GST (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values.totalGSTAmount)}
                onChange={handleChange('totalGSTAmount')}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values.finalAmount)}
                onChange={handleChange('finalAmount')}
                autoFocus={true}
              />
            </Grid>

            <Grid item lg={12} xs={12}>

              <TextField
                type="text"
                label="Payment Instructions "
                placeholder="Optional"
                variant="outlined"
                multiline
                rows={4}
                fullWidth
                inputProps={{
                  // maxLength: 100,
                  className: "abc"

                }}
                value={values.paymentInstruction}
                onChange={handleChange('paymentInstruction')}
                autoFocus={true}
              />
            </Grid>
          </Grid>
          {QuotationID &&
            <Grid item xs={12} md={4} lg={12} mt={1}>
              <Button onClick={() => setExpanded(!expanded)} >
                <Badge badgeContent={quoDocuments.length} sx={{ ".MuiBadge-badge": { backgroundColor: tableBorder, color: "#ffffff" }, }} showZero>
                  <Typography variant="h6" sx={{ border: darkMode ? "1px solid white" : `1px solid ${tableBorder}`, borderRadius: "5px", color: darkMode ? "white" : tableBorder, display: 'flex', alignItems: 'center', marginLeft: "-9px", padding: "1px 10px", fontSize: "12px", }}>
                    Attached Document
                    {expanded ? <ArrowDropDown className="arrowdropdown" style={{ marginLeft: "5px", }} /> : <ArrowDropUpIcon className="arrowdropdown" style={{ marginLeft: "5px", }} />}
                  </Typography>
                </Badge>
              </Button>
            </Grid>}

          {expanded &&
            <>

              <Grid container spacing={2} px={2} pt={2}>

                {/* <Grid item lg={3} xs={4}>
                    <TextField

                      type="text"
                      label="Document Name"
                      placeholder="Document Name"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        maxLength: 30,
                        className: "custom-fieldtext"
                      }}
                      value={values.documentName}
                      onChange={handleChange('documentName')}
                      autoFocus={true}
                      disabled
                    />
                  </Grid> */}
                <Grid item xs={12} lg={3.7}>
                  <label htmlFor="fileInput">
                    <TextField
                      id="quotationDocument"
                      type="text"
                      label="Document File"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        readOnly: true,
                        className: "uploadfile",
                        startAdornment: (
                          <InputAdornment position="start">
                            <label className="ress" htmlFor="fileInput">
                              <Button
                                component="span"
                                size="small"
                                style={{
                                  // color: 'white',
                                  fontSize: "14px", marginTop: "4px",
                                  color: `${darkMode ? "white" : tableBorder}`, marginLeft: "-19px",
                                  textDecoration: "2px solid underline"
                                }}
                              // onClick={() => { !values.documentName && (showResMsg(genericMessage.enterDocumentName, 1000, false)) }}
                              >
                                Choose File
                              </Button>
                            </label>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <input
                      type="file"
                      // accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel,text/csv,vnd.apple.numbers"
                      id="fileInput"
                      style={{ display: "none" }}
                      // disabled={!values.documentName}
                      onChange={saveFile}
                    />
                  </label>
                  <p style={errMsg}>{fileError}</p>
                </Grid>
              </Grid>
              {quoDocuments.length > 0 &&
                <CardContent>
                  <DataTable
                    theme={darkMode ? "solarized" : "light"}
                    columns={documentColumns}
                    data={quoDocuments}
                    fixedHeaderScrollHeight="210px"
                    fixedHeader={true}
                    customStyles={customStyles}

                  />
                </CardContent>}
            </>}
          {/* </>
         } */}



          <Grid
            container
            mt={3.5}
            pb={3}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} lg={1.8}>
              {/* <Link to={"/quotations"}> */}
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                onClick={handleCancel}
              >
                Close
              </MDButton>
              {/* </Link> */}
            </Grid>
            {/* {(!QuotationID || showItemAndDocumentSection) &&
              <> */}
            <Grid item xs={12} md={4} lg={1.8}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                onClick={handleSaveQuotation}
              // disabled={SCREEN_RIGHT !== "Full Access"}
              >
                {/* {QuotationID ? (type !== "clone" ? "Save" : "Clone ") : "Save"} */}
                {QuotationID ? (type !== "clone" ? "Update" : "Clone ") : "Save"}

              </MDButton>
            </Grid>
            {QuotationID && showSendEmailBtn &&
              <Grid item xs={12} md={4} lg={1.8}>
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="info"
                  fullWidth
                  onClick={handleEmailQuotation}
                // onClick={handleSaveWithSendEmail}
                // disabled={SCREEN_RIGHT !== "Full Access" }
                >  Send Email
                </MDButton>
              </Grid>}
            {/* </>
            } */}
          </Grid >
        </Card>
      </div>

      {
        viewDocumentInModal && <Modal
          open={viewDocumentInModal}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            '& .MuiModal-root': {
              width: '100%',
              height: '100%',
            },
          }}
        >
          <Card
            sx={darkMode ?
              { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px", background: "black" } :
              { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px" }
            }
          >
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
              >
                Document Viewer
              </Typography>
              <Box sx={{ width: "100%", height: { xs: "60vh", sm: "70vh" }, overflow: "hidden" }}>
                {selectedFileType === "image" ? (
                  <img
                    title="Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="100%"
                    style={{ display: 'block', objectFit: "contain", aspectRatio: "1/1" }}
                    alt="Document Viewer"
                  />
                ) : selectedFileType === "pdf" ? (
                  <iframe
                    title="Quotation Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="650"
                    allowFullScreen
                  ></iframe>
                ) : null}
              </Box>
              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <MDButton
                  color="warning"
                  className="modalButton"
                  onClick={() => { setViewDocumentInModal(false) }}
                  sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
                >
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>

        </Modal>
      }
      {
        showBillingModal && <BillingModal
          open={showBillingModal}
          handleConfirm={() => { navigate('/subscriptions') }}
          handleCancel={() => { setShowBillingModal(false) }}
          closeModalClick={() => { setShowBillingModal(false) }}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      }

      {
        open && <EmailTemplateModal
          open={open}
          handleClose={handleClose}
          templatesData={templateValues}
          onSend={handleSend}
        />
      }
    </DashboardLayout >
  );
}

export default AddQuotation;

